import React, { Suspense, lazy, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router, Route, Switch, Redirect, useParams} from 'react-router-dom';
import Navbar from './components/navigation/Navbar';
import Searchbar from './components/Searchbar';
import './i18n';
import { useTranslation } from 'react-i18next';
import {Provider, useDispatch, useSelector} from 'react-redux';
import store from './redux/store';
import {FullPageLoader} from "./components/components";
import { ToastContainer } from "./components/ToastContainer";
import {setNavbarSmall} from "./redux/layoutSlice";
import Navigation from "./components/navigation/Navigation";
import Privacy from "./pages/difacto/organisation/Privacy";
import AwsCredentials from "./pages/difacto/organisation/AwsCredentials";
import Navitem from "./components/navigation/Navitem";
import NavitemGroup from "./components/navigation/NavitemGroup";
import Streams from "./routes/difacto/Streams";
import Extracts from "./routes/difacto/Extracts";
import Audiences from "./routes/difacto/Audiences";
import Zones from "./routes/difacto/Zones";
import Api from "./routes/difacto/Api";
import Users from "./routes/difacto/Users";


function Difacto(props) {
	const { t } = useTranslation();
  const dispatch = useDispatch();
  const navbarSmall = useSelector(state => state.layout.navbarSmall)

	const toggleNavbar = () => dispatch(setNavbarSmall(!navbarSmall))

	return (
    <Router>
      <div className="background-container"/>
      <FullPageLoader/>
      <ToastContainer/>
      <div className={navbarSmall ? 'nav-sm' : 'nav-md'}>
        <Suspense fallback={<div>{t('loading')}...</div>}>
          <Navbar />
          <Searchbar handleOnClick={toggleNavbar} />
          <Navigation rootUrl={"/streams"}>
            <Navitem path="/streams" icon='stream' text= {t('menu.streams')} component={Streams}/>
            <Navitem path="/extracts" icon='fileExport' text= {t('menu.extracts')} component={Extracts}/>
            <Navitem path="/audiences" icon='audience' text= {t('menu.audiences')} component={Audiences}/>
            <Navitem path="/zones" icon='map-location' text= {t('menu.zones')} component={Zones}/>
            <Navitem path="/api" icon='brackets' text= {t('menu.api')} component={Api}/>
            <NavitemGroup icon='organisation' text= {t('menu.organisation')}>
              <Navitem path="/users" icon='users' text= {t('menu.users')} component={Users}/>
              <Navitem path="/organisation/privacy" icon='privacy' text= {t('menu.privacy')} component={Privacy}/>
              <Navitem path="/organisation/aws_credentials" icon='aws' text= {t('menu.aws_credentials')} component={AwsCredentials}/>
            </NavitemGroup>
          </Navigation>
        </Suspense>
      </div>
    </Router>
	)
}

document.addEventListener('turbo:load', () => {
	const app = document.getElementById('difacto-app');
	if(app) {
		ReactDOM.render(
      <Provider store={store}>
        <Difacto />
      </Provider>,
      app
    );
	}
})
